import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { useEvent } from "@/context/EventContext";
import { assetUrl } from "@/lib/api";
import { SnapMark } from "@/components/SnapMark";
import { STUDIO } from "@/lib/studio";

export const Header = ({ right }) => {
  const { event } = useEvent();
  const logo = assetUrl(event?.assets?.logo);
  return (
    <header className="sticky top-0 z-30 border-b border-white/10 bg-[#0D0B14]/80 backdrop-blur-xl" data-testid="app-header">
      <div className="mx-auto flex max-w-4xl items-center justify-between gap-4 px-4 py-3 sm:px-6">
        <Link to="/" className="flex items-center gap-2.5 text-white" data-testid="header-home-link">
          <SnapMark size={28} />
          <span className="font-display text-sm font-extrabold tracking-[0.18em]">{STUDIO.mark}</span>
        </Link>
        <div className="flex items-center gap-3">
          {event && (
            <div className="flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-3 py-1.5" data-testid="event-badge">
              {logo && <img src={logo} alt={event.organizer} className="h-5 w-auto rounded-sm bg-white/90 px-1" />}
              <span className="text-xs font-semibold text-slate-200">{event.event_name}</span>
            </div>
          )}
          {right ?? (
            <Link to="/admin" className="btn btn-ghost btn-icon" aria-label="Yönetim" data-testid="admin-link">
              <Lock size={16} />
            </Link>
          )}
        </div>
      </div>
    </header>
  );
};
